import { ValueSet } from "@/models/value-set";
import type { CompanyEntityOptionsResponse } from "@/react/prop-types";

export function transformGroupEntityResponse(data: CompanyEntityOptionsResponse): any {
   const formattedData: any = {};

   if (data.people_options) {
      formattedData.peopleOptions = data.people_options.map((item: any) => new ValueSet(item));
   }
   if (data.user_options) {
      formattedData.userOptions = data.user_options.map((item: any) => new ValueSet(item));
   }
   if (data.tag_options) {
      formattedData.tagOptions = data.tag_options.map((item: any) => new ValueSet(item));
   }
   if (data.categorized_tag_options) {
      const categorizedTags: any = {};
      for (const [key, val] of Object.entries(data.categorized_tag_options)) {
         const category = key !== "null" ? key : "Uncategorized";
         categorizedTags[category] = (val as any[]).map(
            (item: any) => new ValueSet({ name: item.name, value: item.id, color: item.color }),
         );
      }
      formattedData.categorizedTagOptions = categorizedTags;
   }
   if (data.position_options) {
      formattedData.positionOptions = data.position_options.map((item: any) => new ValueSet(item));
   }
   if (data.project_options) {
      formattedData.projectOptions = data.project_options.map((item: any) => new ValueSet(item));
   }
   if (data.active_project_options) {
      formattedData.activeProjectOptions = data.active_project_options.map(
         (item: any) => new ValueSet(item),
      );
   }
   if (data.pending_project_options) {
      formattedData.pendingProjectOptions = data.pending_project_options.map(
         (item: any) => new ValueSet(item),
      );
   }
   if (data.inactive_project_options) {
      formattedData.inactiveProjectOptions = data.inactive_project_options.map(
         (item: any) => new ValueSet(item),
      );
   }

   // Custom field filters with sorting
   const transformCustomFields = (fields: any[]) => {
      return fields.map((field: any) => {
         if (
            (field.type === "multi-select" || field.type === "select") &&
            field.sort_by === "alpha"
         ) {
            const sortedValues = field.values.sort((a: any, b: any) =>
               String(a).toLowerCase() > String(b).toLowerCase() ? 1 : -1,
            );
            return { ...field, values: sortedValues };
         }
         return field;
      });
   };

   if (data.assignments_custom_field_filters) {
      formattedData.assignmentsCustomFieldFilters = transformCustomFields(
         data.assignments_custom_field_filters,
      );
   }
   if (data.people_custom_field_filters) {
      formattedData.peopleCustomFieldFilters = transformCustomFields(
         data.people_custom_field_filters,
      );
   }
   if (data.projects_custom_field_filters) {
      formattedData.projectsCustomFieldFilters = transformCustomFields(
         data.projects_custom_field_filters,
      );
   }
   if (data.requests_custom_field_filters) {
      formattedData.requestsCustomFieldFilters = transformCustomFields(
         data.requests_custom_field_filters,
      );
   }

   if (data.people_custom_fields) {
      formattedData.peopleCustomFields = data.people_custom_fields;
   }
   if (data.projects_custom_fields) {
      formattedData.projectsCustomFields = data.projects_custom_fields;
   }

   if (data.grouped_cost_code_options) {
      const groupedCostCodeOptions: any = {};
      for (const [key, val] of Object.entries(data.grouped_cost_code_options)) {
         groupedCostCodeOptions[key] = (val as any[]).map((item: any) => new ValueSet(item));
      }
      formattedData.groupedCostCodeOptions = groupedCostCodeOptions;
   }
   if (data.grouped_label_options) {
      const groupedLabelOptions: any = {};
      for (const [key, val] of Object.entries(data.grouped_label_options)) {
         groupedLabelOptions[key] = (val as any[]).map((item: any) => new ValueSet(item));
      }
      formattedData.groupedLabelOptions = groupedLabelOptions;
   }

   return formattedData;
}
